import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AccessTokenService } from 'src/app/Services/access-token.service';
import { UserDataProviderService } from 'src/app/Services/user-data-provider.service';

@Component({
  selector: 'app-okta-callback-handler',
  standalone: true,
  template: '',
})
export class OktaCallbackHandlerComponent implements OnInit {
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private accessTokenService: AccessTokenService,
    private userDataProviderService: UserDataProviderService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      // Exchange auth code for tokens and store them — no navigation side-effect
      await this.oktaAuth.storeTokensFromRedirect();
      const tokenContainer = await this.oktaAuth.tokenManager.getTokens();
      const idToken = tokenContainer.idToken;
      if (!idToken) {
        this.router.navigateByUrl('/login?error=UNAUTHORIZED_SSO_LOGIN');
        return;
      }
      const email = (idToken.claims as any).email ?? (idToken.claims as any).preferred_username;
      this.accessTokenService.getUserSSOAccessTokenAndProceed(
        { idToken: idToken.idToken, email },
        'Okta'
      ).subscribe((response) => {
        localStorage.removeItem('oktaLogin');
        if (response.body?.status === 'success' && response.status === 200) {
          this.accessTokenService.processLogin(response);
          this.userDataProviderService.isShowSidebar.emit(true);
        } else {
          this.router.navigateByUrl('/login?error=UNAUTHORIZED_SSO_LOGIN');
        }
      });
    } catch (err) {
      console.error('[OktaCallback] PKCE/token exchange failed', err);
      this.router.navigateByUrl('/login?error=UNAUTHORIZED_SSO_LOGIN');
    }
  }
}
